import React, { useState } from 'react'; // Adiciona useState
import { Button, Modal, Form, Spinner, Table, Tabs, Tab, Dropdown } from 'react-bootstrap'; // Adiciona Tabs e Tab
import CurrencyInput from 'react-currency-input-field';

const MaterialTab = ({
  tiposMateriais,
  isLoading,
  showModal,
  handleCloseModal,
  handleOpenModal,
  handleToggleStatus,
  mostrarInativos,
  setMostrarInativos,
  handleOpenMergeModal, // Nova prop para o modal de unificação
  novoMaterial,
  handleChange,
  handleSubmit,
  getQuantidadeEmEstoque,
}) => {
  const [activeModalTabKey, setActiveModalTabKey] = useState('dadosBasicos');

  // Adiciona um botão para abrir o modal de unificação
  const renderActionButtons = () => (
    <div className="mb-3 d-flex justify-content-between align-items-center">
        <div className="d-flex gap-2">
            <Button variant="primary" onClick={handleOpenModal}>
                Novo Material
            </Button>
            <Dropdown>
                <Dropdown.Toggle variant="outline-secondary" id="dropdown-acoes-materiais">Ações</Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={handleOpenMergeModal}>Unificar Tipos de Materiais</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
        <Form.Check 
            type="switch"
            id="mostrar-inativos-switch"
            label="Mostrar inativos"
            checked={mostrarInativos}
            onChange={(e) => setMostrarInativos(e.target.checked)}
        />
    </div>
  );

  const unidadesDeMedida = [
    { valor: '', rotulo: 'Selecione...' },
    { valor: 'Unidade', rotulo: 'Unidade' },
    { valor: 'Grama', rotulo: 'Grama' },
    { valor: 'Ml', rotulo: 'Ml' },
    { valor: 'Quilo', rotulo: 'Quilo' },
    { valor: 'Metro', rotulo: 'Metro' },
    { valor: 'Metro Cúbico', rotulo: 'Metro Cúbico' },
  ];

  return (
    <>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Criar Novo Material</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            activeKey={activeModalTabKey}
            onSelect={(k) => setActiveModalTabKey(k)}
            id="material-modal-tabs"
            className="mb-3"
          >
            <Tab eventKey="dadosBasicos" title="Dados Básicos">
              <Form onSubmit={handleSubmit}> {/* O onSubmit pode ficar no Form geral ou ser movido para o botão Salvar */}
                <Form.Group controlId="nomeMaterialTab" className="mb-3">
                  <Form.Label>Nome:</Form.Label>
                  <Form.Control
                    type="text"
                    name="nome"
                    value={novoMaterial.nome}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="descricaoMaterialTab" className="mb-3">
                  <Form.Label>Descrição:</Form.Label>
                  <Form.Control
                    type="text"
                    name="descricao"
                    value={novoMaterial.descricao}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group controlId="valorMaterialTab" className="mb-3">
                  <Form.Label>Valor Total (R$):</Form.Label>
                  <CurrencyInput
                    id="valorMaterialTabInput"
                    name="valor"
                    className="form-control"
                    placeholder="R$ 0,00"
                    defaultValue={novoMaterial.valor || 0}
                    decimalsLimit={2}
                    decimalSeparator=","
                    groupSeparator="."
                    prefix="R$ "
                    onValueChange={(value, name) => handleChange({ target: { value, name } }, name)}
                  />
                </Form.Group>

                <Form.Group controlId="unidadeMedidaMaterialTab" className="mb-3">
                  <Form.Label>Unidade de Medida:</Form.Label>
                  <Form.Control
                    as="select"
                    name="unidade_medida"
                    value={novoMaterial.unidade_medida || ''}
                    onChange={handleChange}
                    required
                  >
                    {unidadesDeMedida.map(unidade => (
                      <option key={unidade.valor} value={unidade.valor}>
                        {unidade.rotulo}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>

                <Form.Group controlId="quantidadeAdquiridaMaterialTab" className="mb-3">
                  <Form.Label>Quantidade Adquirida:</Form.Label>
                  <Form.Control
                    type="number"
                    name="quantidade_adquirida"
                    value={novoMaterial.quantidade_adquirida}
                    onChange={handleChange}
                    min="0"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="valorUnidadeMaterialTab" className="mb-3">
                  <Form.Label>Valor Unitário (R$):</Form.Label>
                  <Form.Control
                    type="text"
                    name="valor_unidade"
                    value={novoMaterial.valor_unidade}
                    readOnly
                  />
                </Form.Group>
              </Form>
            </Tab>
            <Tab eventKey="dadosAdicionais" title="Dados Adicionais">
              <Form onSubmit={handleSubmit}> {/* O onSubmit pode ficar no Form geral ou ser movido para o botão Salvar */}
                <Form.Group controlId="fornecedorMaterialTab" className="mb-3">
                  <Form.Label>Fornecedor:</Form.Label>
                  <Form.Control
                    type="text"
                    name="fornecedor"
                    value={novoMaterial.fornecedor}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group controlId="fabricanteMaterialTab" className="mb-3">
                  <Form.Label>Fabricante:</Form.Label>
                  <Form.Control
                    type="text"
                    name="fabricante"
                    value={novoMaterial.fabricante}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group controlId="numeroSerieMaterialTab" className="mb-3">
                  <Form.Label>Número de Série:</Form.Label>
                  <Form.Control
                    type="text"
                    name="numero_serie"
                    value={novoMaterial.numero_serie}
                    onChange={handleChange}
                  />
                </Form.Group>
                

                <Form.Group controlId="loteMaterialTab" className="mb-3">
                  <Form.Label>Lote:</Form.Label>
                  <Form.Control type="text" name="lote" value={novoMaterial.lote} onChange={handleChange} />
                </Form.Group>
                <Form.Group controlId="validadeMaterialTab" className="mb-3">
                  <Form.Label>Validade:</Form.Label>
                  <Form.Control type="date" name="validade" value={novoMaterial.validade} onChange={handleChange} />
                </Form.Group>
                <Form.Group controlId="estoqueMinimoMaterialTab" className="mb-3">
                  <Form.Label>Estoque Mínimo:</Form.Label>
                  <Form.Control type="number" name="estoque_minimo" value={novoMaterial.estoque_minimo} onChange={handleChange} min="0" required />
                </Form.Group>
                <Form.Group controlId="estoqueMaximoMaterialTab" className="mb-3">
                  <Form.Label>Estoque Máximo:</Form.Label>
                  <Form.Control type="number" name="estoque_maximo" value={novoMaterial.estoque_maximo} onChange={handleChange} min="0" />
                </Form.Group>
              </Form>
            </Tab>
          </Tabs>
          {/* Botão Salvar fora das abas, mas dentro do Modal.Body se o Form for único, ou no Footer */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? <Spinner animation="border" size="sm" /> : 'Salvar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {renderActionButtons()}

      {isLoading ? (
        <div className="text-center mt-3"><Spinner animation="border" /></div>
      ) : (
        <Table striped bordered hover style={{ width: '98%' }} className="mt-3">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Descrição</th>
              <th>Unidade de Medida</th>
              <th>Quantidade em estoque</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {tiposMateriais.map((tipoMaterial) => (
              <tr key={tipoMaterial.id}>
                <td>{tipoMaterial.nome}</td>
                <td>{tipoMaterial.descricao}</td>
                <td>{tipoMaterial.unidade_medida}</td>
                <td>{getQuantidadeEmEstoque(tipoMaterial.id)} {tipoMaterial.unidade_medida}</td>
                <td>
                  <Button 
                    variant={mostrarInativos ? "outline-success" : "outline-danger"} 
                    size="sm" 
                    onClick={() => handleToggleStatus(tipoMaterial.id)}
                  >
                    <i className="fas fa-power-off"></i> {mostrarInativos ? 'Reativar' : 'Inativar'}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default MaterialTab;